import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { DropdownThreeDotsIcon } from '@design-system/dropdown';
import { __ } from '@design-system/i18n';
import { FONT_BRIGHTNESS } from '@design-system/theme';
import { useCallback } from 'react';
import { styled } from 'styled-components';
const ThreeDotActions = ({ actions }) => (_jsx(Box, { onClick: (e) => e.stopPropagation(), position: "absolute", right: 4, top: 4, children: _jsx(DropdownThreeDotsIcon, { items: actions, title: __('More actions') }) }));
export const ContentListItemWithBorder = ({ children, getActions, item, }) => {
    const handleItemClick = useCallback(() => {
        var _a;
        if ('onClick' in item) {
            (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
        }
    }, [item]);
    const handleKeyDown = useCallback((event) => {
        var _a;
        if (event.key === 'Enter' && 'onClick' in item) {
            event.preventDefault();
            (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
        }
    }, [item]);
    return (_jsxs(ContentRecommendationItemWrapper, { onClick: handleItemClick, onKeyDown: handleKeyDown, role: "link", tabIndex: 0, children: [getActions && _jsx(ThreeDotActions, { actions: getActions(item) || [] }), children] }));
};
const ContentRecommendationItemWrapper = styled(Box).attrs({
    p: { _: 0, m: 4 },
    mb: 5,
    height: { _: '163px', m: '145px' },
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 100%;

  border: 1px solid
    ${({ theme }) => {
    if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
    }
    return theme.colors.horizon;
}};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;
//# sourceMappingURL=ContentListItemWithBorder.js.map